import React from "react";

import Image from "next/image";

import BackgroundImage from "public/images/enerflo-background-solar-sun.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Enerflo is Purpose-Built";

const MainHero = () => (
  <div className="relative py-20 md:py-36">
    <Image
      src={BackgroundImage}
      alt="solar sun background"
      layout="fill"
      className="object-center object-cover crispImage"
      priority
      loading="eager"
    />
    <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-transparent" />
    <HeroSection title={title}>
      <HeroSection.Content className="text-white">
        <HeroSection.Header className="md:items-start">
          <Heading tag="h1">{title}</Heading>
        </HeroSection.Header>
        <p className="text-xl text-gray-200 md:max-w-[50%]">
          We’re on a mission to help democratize solar energy and spread it across the globe, one well-executed deal at
          a time.
        </p>
      </HeroSection.Content>
    </HeroSection>
  </div>
);

export default MainHero;
